module.exports = __webpack_public_path__ + "img/info-three-bg.77615942.png";